"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureMsal = exports.AuthProviderState = void 0;
var react_1 = __importStar(require("react"));
var msal_browser_1 = require("@azure/msal-browser");
var MicrosoftGraph = __importStar(require("@microsoft/microsoft-graph-client"));
var AuthProviderState;
(function (AuthProviderState) {
    AuthProviderState["Loading"] = "Loading";
    AuthProviderState["Success"] = "Success";
    AuthProviderState["Error"] = "Error";
})(AuthProviderState = exports.AuthProviderState || (exports.AuthProviderState = {}));
function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
exports.configureMsal = function (params) {
    var msalClient = new msal_browser_1.PublicClientApplication(params.config);
    var msalScopes = params.msalScopes || [];
    var graphScopes = params.graphClientScopes || [];
    var getAccessToken = function (scopes) { return __awaiter(void 0, void 0, void 0, function () {
        var account, accessToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    account = msalClient.getAllAccounts();
                    return [4 /*yield*/, msalClient.acquireTokenSilent({
                            account: account[0],
                            scopes: (scopes ? scopes : __spreadArrays(msalScopes, graphScopes)).filter(onlyUnique),
                        })];
                case 1:
                    accessToken = (_a.sent()).accessToken;
                    return [2 /*return*/, accessToken];
            }
        });
    }); };
    var useAccount = function () {
        var account = react_1.useContext(Account);
        if (!account) {
            throw new Error("PartnerSettings not found");
        }
        return account;
    };
    var Account = react_1.default.createContext(null);
    Account.displayName = 'PartnerSettings';
    var graphClient = MicrosoftGraph.Client.init({
        // Use the provided access token to authenticate
        // requests
        authProvider: function (done) {
            getAccessToken(graphScopes).then(function (token) {
                done(null, token);
            });
        },
    });
    var AuthProvider = function (props) {
        var _a = react_1.default.useState(AuthProviderState.Loading), authState = _a[0], setAuthState = _a[1];
        var _b = react_1.default.useState(), account = _b[0], setAccount = _b[1];
        var getUserProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // console.log('trying to get user profile')
                try {
                    // Get the user's profile from Graph
                    // const user = await graphClient.api('/me').get()
                    // console.log('user: ', user)
                    setAuthState(AuthProviderState.Success);
                }
                catch (err) {
                    setAuthState(AuthProviderState.Error);
                }
                return [2 /*return*/];
            });
        }); };
        var login = function () { return __awaiter(void 0, void 0, void 0, function () {
            var tokenResponse, accountObj, err_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 11, , 12]);
                        return [4 /*yield*/, msalClient.handleRedirectPromise()];
                    case 1:
                        tokenResponse = _a.sent();
                        accountObj = !!tokenResponse
                            ? tokenResponse.account
                            : msalClient.getAllAccounts()[0];
                        if (!(accountObj && tokenResponse)) return [3 /*break*/, 2];
                        setAuthState(AuthProviderState.Success);
                        setAccount(accountObj);
                        return [3 /*break*/, 10];
                    case 2:
                        if (!accountObj) return [3 /*break*/, 8];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 7]);
                        return [4 /*yield*/, msalClient.acquireTokenSilent({
                                account: msalClient.getAllAccounts()[0],
                                scopes: msalScopes,
                            })];
                    case 4:
                        tokenResponse = _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        err_1 = _a.sent();
                        return [4 /*yield*/, msalClient.acquireTokenRedirect({
                                scopes: msalScopes,
                            })];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 10];
                    case 8: 
                    // console.log(
                    //   '[AuthService.init] No accountObject or tokenResponse present. User must now login.',
                    // )
                    return [4 /*yield*/, msalClient.loginRedirect({ scopes: msalScopes })];
                    case 9:
                        // console.log(
                        //   '[AuthService.init] No accountObject or tokenResponse present. User must now login.',
                        // )
                        _a.sent();
                        _a.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_1 = _a.sent();
                        setAuthState(AuthProviderState.Error);
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        }); };
        react_1.useEffect(function () {
            var accounts = msalClient.getAllAccounts();
            // console.log('accounts: ', accounts)
            if (accounts && accounts.length > 0) {
                // Enhance user object with data from Graph
                setAccount(accounts[0]);
                getUserProfile();
            }
            else {
                login();
            }
        }, []);
        if (!account) {
            return react_1.default.createElement(react_1.default.Fragment, null, props.render({ account: account, state: authState }));
        }
        return (react_1.default.createElement(Account.Provider, { value: account }, props.render({ account: account, state: authState })));
    };
    return {
        msalClient: msalClient,
        graphClient: graphClient,
        AuthProvider: AuthProvider,
        getAccessToken: getAccessToken,
        msalScopes: msalScopes,
        graphScopes: params.graphClientScopes,
        useAccount: useAccount,
    };
};
//# sourceMappingURL=AuthProvider.js.map